<template>
  <div class="banner B1">
    <AdTip
      :tipClass="subscribeStatus === 2 ? 'blue' : ''"
      :viewDetail="subscribeStatus !== 2"
    />
    <div class="row1 sepTop">
      <div class="priceArea S8 C1">
        <div v-if="subscribeStatus === 1" class="T6">
          有效期至{{
            dayjs(resp.detail.detail.expireTime).format('YYYY-MM-DD')
          }}
        </div>
        <template v-else>
          <template v-if="videoType === 'shrink'">
            <div style="font-weight: bold">
              {{ displayPrice }}
            </div>
          </template>
          <template v-else>
            <div>
              ￥
            </div>
            <div style="font-weight: bold">
              {{ price }}
            </div>
            <div>
              /套
            </div>
            <div class="S4 T3 orignPrice" v-if="isShowOriginalPrice">
              ￥{{ originalPrice }}
            </div>
          </template>
        </template>
      </div>
      <div class="S8 T5 btnBuy" @click="goBuy">
        <span v-if="subscribeStatus === 1">续订</span>
        <span v-else-if="subscribeStatus === 2">再次订阅</span>
        <span v-else>立即订购</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdTip from '@/views/video/AdTip'
import util from '@/util/util'
import { isGuest } from '@/api/appInfo'
import { isIOS } from '@/api/appInfo'
import dayjs from 'dayjs'

export default {
  name: 'PayBanner',
  components: { AdTip },
  props: ['subscribeStatus', 'videoType'],
  methods: {
    dayjs,
    goBuy() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      if (!this.resp.detail.detail.payUrl) {
        this.$toast('支付地址不存在')
        return
      }
      let uri = 'ycstock://web?url=' + escape(this.resp.detail.detail.payUrl)
      util.go(uri)
    }
  },
  computed: {
    ...mapState('video', ['resp']),

    price() {
      if (this.resp.detail) {
        if (isIOS()) {
          return this.resp.detail.detail.applePrice
        } else {
          return this.resp.detail.detail.price
        }
      }
      return ''
    },

    displayPrice() {
      if (this.resp.detail) {
        if (isIOS()) {
          return this.resp.detail.detail.displayApplePrice
        } else {
          return this.resp.detail.detail.displayPrice
        }
      }
      return ''
    },

    originalPrice() {
      if (this.resp.detail) {
        if (isIOS()) {
          return this.resp.detail.detail.originalApplePrice
        } else {
          return this.resp.detail.detail.originalPrice
        }
      }
      return ''
    },

    isShowOriginalPrice() {
      if (this.price < this.originalPrice) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.row1 {
  height: 98px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  background: #fff;
  bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}

.btnBuy {
  width: 240px;
  height: 100%;
  background: #e64c2e;
  line-height: 98px;
  text-align: center;
  position: absolute;
  right: 0;
}

.orignPrice {
  text-decoration: line-through;
  margin-left: 10px;
}

.priceArea {
  margin-left: 30px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
